<template>
  <span class="date-picker-wrapper">
    <date-picker v-model.range="value"
                 class="date-picker"
                 :locale="localeConfiguration"
                 mode="date"
                 :model-config="modelConfig"
                 :transition="transition"
                 :popover="{visibility: 'focus', transition}"
                 @update:model-value="changed">
      <template #default="{ inputValue, inputEvents, isDragging }">
        <div class="d-flex flex-wrap gap-1 my-1">
          <input class="date-picker-input p-1 form-control"
                 name="start_date"
                 :value="inputValue.start"
                 v-on="inputEvents.start">
          ~<input class="date-picker-input p-1 form-control"
                  :class="{'text-white': isDragging}"
                  name="end_date"
                  :value="inputValue.end"
                  v-on="inputEvents.end">
        </div>
      </template>
    </date-picker>
  </span>
</template>

<script>
import { DateTime } from 'luxon'
import { DatePicker } from 'v-calendar'
import DatePickerMixin from './date-picker-mixin'

// recommended by https://vcalendar.io/getting-started/installation.html
import 'v-calendar/style.css'

export default {
  components: { DatePicker },

  mixins: [ DatePickerMixin ],

  props: {
    initialValue: {
      type: [Object],
      required: false
    }
  },

  emits: ['change'],

  data() {
    let value
    if (this.initialValue) {
      value = {
        start: this.initialValue.start_date,
        end: this.initialValue.end_date
      }
    }

    return {
      value,
      modelConfig: {
        timeAdjust: '00:00:00'
      },
      transition: this.agraConfiguration.disableAnimations ? 'none' : 'focus'
    }
  },

  methods: {
    changed(newValue) {
      if (newValue) {
        const {start:startTime, end:endTime} = newValue
        if (startTime && endTime) {
          // Move endTime forward to the last second of the end date.
          // This is to adjust for the fact that the datepicker component will capture the first second
          // of the input end date, but in our use cases where we use this component,
          // we want the entirety of the end date to be included in the range.
          const adjustedValue = [
            startTime,
            DateTime.fromJSDate(endTime).plus({day: 1}).minus({second: 1}).toUTC().toString()
          ]
          this.$emit('change', adjustedValue)
        }
        else {
          // Range invalid, reset it.
          this.$emit('change', null)
        }
      }
      else {
        // Range empty, reset it.
        this.$emit('change', null)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "~mixins/rtl_only" as rtl_override;

  .date-picker-input {
    width: 105px;
  }

  .date-picker-wrapper {
    // In RTL: flip the navigation arrows vertically
    ::v-deep(.vc-arrows-container) {
      .vc-arrow.vc-prev, .vc-arrow.vc-next {
        svg {
          @include rtl_override.rtl-only {
            transform: rotate(180deg);
          }
        }
      }
    }

    // Fix month name and prev/next button background color
    ::v-deep(.vc-header button) {
      background: transparent;
    }
  }
</style>
